import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import { ResultConcepts } from 'modules/payroll_bundle/lib/constants'
import paymentItems from 'modules/payroll_bundle/store/collections/paymentItems'

interface IPayment {
  [key: string]: any
}

// PaymentStatus
export const PENDING = 'pending'
export const PAID = 'paid'

export const PAYMENT_SOURCE_EXTERNAL = 'external'
export const PAYMENT_SOURCE_FACTORIAL = 'factorial'
type PAYMENT_SOURCE = typeof PAYMENT_SOURCE_EXTERNAL | typeof PAYMENT_SOURCE_FACTORIAL

class Payment extends Model<IPayment> {
  constructor(attr: IPayment = {}) {
    super(attr)
    makeObservable(this, {
      totalEmployees: computed,
      paymentsTotalAmount: computed,
      concept: computed,
      paymentItems: computed,
    })
  }

  static urlRoot() {
    return '/payroll/payments'
  }

  get paymentsTotalAmount(): number {
    return this.paymentsWithEmployees().reduce((acc, paymentItem) => {
      return acc + parseInt(paymentItem.attributes.amount_in_cents)
    }, 0)
  }

  get totalEmployees(): number {
    return this.paymentsWithEmployees().length
  }

  get concept() {
    return this.attributes.concept ?? ResultConcepts.regular_payroll
  }

  get paymentItems() {
    return paymentItems.paymentItemByPaymentId(this.attributes.id)
  }

  async changeStatus(data: { status: string; paymentSource: PAYMENT_SOURCE }): Promise<void> {
    const payment = await this.rpc('change_status', {
      status: data.status,
      payment_source: data.paymentSource,
    })
    this.set(payment)
  }

  paymentsWithEmployees = () => {
    return paymentItems.filter((paymentItem) => {
      return this.id === paymentItem.attributes.payment_id && paymentItem.attributes.employee_id
    })
  }

  employeePaymentItems = (employeeId: string) => {
    return this.paymentItems.filter(
      (paymentItem) => paymentItem.attributes.employee_id === employeeId
    )
  }
}

export default Payment
